import { queryOptions } from "@tanstack/react-query";

import { type Me, fetchMe } from "@/features/auth/api";

export const sessionQuery = queryOptions<Me>({
  queryKey: ["auth", "me"],
  queryFn: fetchMe,
  // The session decides what the whole shell renders, so it is fetched
  // once per load and kept. `retry: false` because the client already
  // tried a refresh before this could fail — retrying past that just
  // delays the redirect to login.
  retry: false,
  staleTime: 5 * 60_000,
});
